<div class="rate-us-dialog">
  <div class="rate-us-dialog_title">
    <h1 class="mat-display-medium">
      <strong>You rated us {{data.usersRating}}.<br class="title-break"> Would you like to submit this rating?</strong>
    </h1>
  </div>
  <div class="rate-us-dialog_form">
    <form [formGroup]="form" (ngSubmit)="saveRating(form.value)">
      <mat-form-field appearance="outline" hideRequiredMarker="true" floatLabel="never" class="rating_textarea">

        <mat-label>Enter comment (optional)</mat-label>
        <textarea matInput class="mat-body-medium bddc-dark-blue bold borderless {{form.invalid ? 'invalid' : ''}}"
        formControlName="customerRating"></textarea>

      </mat-form-field>
      @if (form.invalid && form.controls.customerRating.value.length > 1500) {
        <mat-error>Message cannot be more than
        1500 characters.</mat-error>
      }
      @if (form.invalid && form.controls.customerRating.errors.htmlExists != null) {
        <mat-error>This message contains
        invalid content.</mat-error>
      }
      <div class="rate-us-dialog_form-actions" mat-dialog-actions>
        <button mat-raised-button color="primary" [disabled]="form.invalid">Submit</button>
        <a mat-raised-button (click)="closeDialog()" class="cancel-button">Cancel</a>
      </div>
    </form>
  </div>
</div>